const apiHost = process.env.REACT_APP_API_SERVER

export const getUser = async (dispatch, userId) => {
  if (!userId) {
    return
  }
  try {
    const data = await fetch(`${apiHost}/submitter/${userId}`).then(r => r.json())
    dispatch({ type: 'INIT_DATA', data })
  } catch (error) {
    console.log('error connecting to api', error)
  }
}

export const updateAnswers = async (userId, answers) => {
  if (!answers || !userId) {
    return
  }

  try {
    await fetch(`${apiHost}/update-answers/${userId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ answers }),
    }).then(r => r.json())
  } catch (error) {
    console.log('error updating answers', error)
  }
}

export const setScreen = (dispatch, screen) => {
  dispatch({ type: 'SET_SCREEN', screen })
}

export const nextQuestion = dispatch => {
  dispatch({ type: 'NEXT_QUESTION' })
}

export const previousQuestion = dispatch => {
  dispatch({ type: 'PREVIOUS_QUESTION' })
}

export const restart = dispatch => {
  dispatch({ type: 'RESTART' })
}

export const nextTheme = dispatch => {
  dispatch({ type: 'NEXT_THEME' })
}

export const selectQuestion = (dispatch, selectedTheme, selectedQuestion) => {
  dispatch({ type: 'SELECT_QUESTION', selectedTheme, selectedQuestion })
}

export const updateAnswer = (dispatch, answer) => {
  dispatch({ type: 'UPDATE_ANSWER', answer })
}
